import React, {FC, useState} from 'react'
import {Layout} from '../../ui'
import {Analysis, ContactForm, Step1, Step2, Step3, Step4} from './steps'
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {useTranslation} from '../../../providers/LocalizationProvider'

const Quiz: FC = () => {
    const [currentStep, setCurrentStep] = useState(0)
    const [isAnalyzing, setIsAnalyzing] = useState(false)
    const [promtText, setPromtText] = useState('')
    const [answers, setAnswers] = useState({
        propertyType: '',
        rooms: [] as string[],
        goal: '',
        budget: ''
    })
    const {executeRecaptcha} = useGoogleReCaptcha()
    const {language, t} = useTranslation();

    const handleNext = () => {
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1)
            window.scrollTo({top: 0, behavior: 'smooth'})
        }
    }

    const handleSubmit = () => {
        window.dataLayer.push({
            'event': 'final',
            'eventCategory': 'quiz',
            'eventAction': 'finalbutton'
        });
        setIsAnalyzing(true)
    }

    const handleAnalysisComplete = () => {
        setCurrentStep(4)
        setIsAnalyzing(false)
    }

    const handleContactMethodSelect = async (data: { name: string; phone: string }) => {
        // Капча готова?
        if (!executeRecaptcha) {
            setCurrentStep(6)
            setPromtText(t("error.recaptcha_loading"))
            return
        }

        // Подготовим объект для отправки
        const submissionData = {
            ...answers,
            name: data.name,
            phone: data.phone,
            recaptcha: {
                token: await executeRecaptcha('newlead')
            },
            ln: language,
            url_params: JSON.parse(localStorage.getItem('url_params') ?? '')
        }

        // Попытка в новый Лид
        setCurrentStep(5)
        fetch('../api/newlead.php', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(submissionData),
        })
            .then(response => response.json())
            .then(data => {
                console.log(data)
                if (data.status === 'success') {
                    if(!data.timestamp) {
                        window.dataLayer.push({
                            'event': 'NewLead',
                            'eventCategory': 'quiz',
                            'eventAction': 'lead'
                        });
                    }
                    setCurrentStep(7)
                    setPromtText(data.message)
                } else {
                    throw new Error(data.message)
                }
            })
            .catch(error => {
                setCurrentStep(6)
                setPromtText(error.message || String(error))
                console.error(error)
            })
    }

    const handleReturnToContactForm = () => {
        setCurrentStep(4)
    }

    if (isAnalyzing) {
        return (
            <Layout hiddenHeader>
                <Analysis onComplete={handleAnalysisComplete}/>
            </Layout>
        )
    }

    if (currentStep === 4) {
        return (
            <Layout hiddenHeader>
                <ContactForm onSubmit={handleContactMethodSelect}/>
            </Layout>
        )
    }

    // процессинг
    if (currentStep === 5) {
        return (
            <Layout hiddenHeader>
                <div
                    className='bg-grey-100 min-h-screen flex items-center py-8 md:py-0 relative bg-center bg-cover'
                    style={{backgroundImage: `url(/form-bg.png)`}}>
                    <div className='max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8'>
                        <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center relative z-10'>
                            <div className='rounded-3xl p-8 sm:p-10'>
                                <center><img src='/loading_icon_128.gif' alt='Loading...'/></center>
                            </div>
                            <div className='hidden lg:flex items-center justify-center'>
                                <div className='relative w-full max-w-full'>
                                    <img src='/form.png'
                                         alt={t("image_alt.podborka_nedvijimosti")}
                                         className='w-full h-auto'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }

    // Ошибка
    if (currentStep === 6) {
        return (
            <Layout hiddenHeader>
                <div
                    className='bg-grey-100 min-h-screen flex items-center py-8 md:py-0 relative bg-center bg-cover'
                    style={{backgroundImage: `url(/form-bg.png)`}}>
                    <div className='max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8'>
                        <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center relative z-10'>
                            <div className='rounded-3xl p-8 sm:p-10'>
                                <p className='text-grey-400 font-medium mb-8'>
                                    {promtText}
                                </p>
                                <button onClick={handleReturnToContactForm}
                                        className='py-3 px-8 md:w-auto w-full bg-black hover:bg-black/80 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-full transition-all mt-6'>
                                    {t("back_to_form")}
                                </button>
                            </div>
                            <div className='hidden lg:flex items-center justify-center'>
                                <div className='relative w-full max-w-full'>
                                    <img src='/form.png'
                                         alt={t("image_alt.podborka_nedvijimosti")}
                                         className='w-full h-auto'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }

    // Успех
    if (currentStep === 7) {
        return (
            <Layout hiddenHeader>
                <div
                    className='bg-grey-100 min-h-screen flex items-center py-8 md:py-0 relative bg-center bg-cover'
                    style={{backgroundImage: `url(/form-bg.png)`}}>
                    <div className='max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8'>
                        <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center relative z-10'>
                            <div className='rounded-3xl p-8 sm:p-10'>
                                <p className='text-grey-400 font-medium mb-8'>
                                    {promtText}
                                </p>
                                <a href="/">
                                    <button
                                        className='py-3 px-8 md:w-auto w-full bg-black hover:bg-black/80 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-full transition-all mt-6'>
                                        {t("to_main_page")}
                                    </button>
                                </a>
                            </div>
                            <div className='hidden lg:flex items-center justify-center'>
                                <div className='relative w-full max-w-full'>
                                    <img src='/form.png'
                                         alt={t("image_alt.podborka_nedvijimosti")}
                                         className='w-full h-auto'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }

    return (
        <Layout hiddenHeader>
            <div className='bg-white py-12 md:py-20 relative'>
                <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
                    {currentStep === 0 && (
                        <Step1
                            selectedType={answers.propertyType}
                            onTypeChange={type =>
                                setAnswers({...answers, propertyType: type})
                            }
                            onNext={handleNext}
                        />
                    )}

                    {currentStep === 1 && (
                        <Step2
                            selectedRooms={answers.rooms}
                            onRoomsChange={rooms => setAnswers({...answers, rooms})}
                            onNext={handleNext}
                        />
                    )}

                    {currentStep === 2 && (
                        <Step3
                            selectedGoal={answers.goal}
                            onGoalChange={goal => setAnswers({...answers, goal})}
                            onNext={handleNext}
                        />
                    )}

                    {currentStep === 3 && (
                        <Step4
                            selectedBudget={answers.budget}
                            onBudgetChange={budget => setAnswers({...answers, budget})}
                            onSubmit={handleSubmit}
                        />
                    )}
                </div>
            </div>
        </Layout>
    )
}

export default Quiz
